export const SOCIAL_SOURCE_LABEL = "Kolsquare";
